export default __webpack_public_path__ + "static/media/profile2.ed1cb5bd.png";